<template>
  <v-card class="pa-1 max-shadow">
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <avatar
            :text="post.author.name"
            :size="40"
            :src="post.author.photo"
          />
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>
            <span class="body-2">
              {{ post.author.name }}
            </span>
          </v-list-tile-title>
          <v-list-tile-sub-title>
            <span class="caption">
              {{ formatTime(post.createdAt) }}
            </span>
          </v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn color="primary" icon flat @click="$emit('delete', post)">
            <v-icon>delete</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
      <v-card-title class="px-2 py-1 body-1">
        {{ postBody }}
      </v-card-title>
      <v-container grid-list-sm fluid class="pa-1">
        <v-layout row wrap>
          <template v-for="(media, index) in post.content.media">
            <v-flex :key="index" xs12>
              <v-img
                v-if="media.type === 'image'"
                style="border-radius: 6px"
                :aspect-ratio="1.3"
                :src="media.url"
              />
            </v-flex>
          </template>
        </v-layout>
      </v-container>
      <v-card-actions>
        <span class="body-1 pr-3">
          {{ likes }}
          <v-icon small> mdi-heart-outline </v-icon>
        </span>
        <span>
          {{ noOfComments }}
          <v-icon small @click="showPost"> mdi-comment-outline </v-icon>
        </span>
      </v-card-actions>
    </v-list>
    <comments v-if="showComments" :feed-id="post.id" />
  </v-card>
</template>
<script>
import Avatar from '@/components/common/Avatar';
import Comments from './Comments';
import * as moment from 'moment';

export default {
  name: 'Post',
  components: {
    avatar: Avatar,
    comments: Comments,
  },
  props: {
    post: {
      type: Object,
      required: true,
      default: () => {},
    },
    showComments: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    noOfComments() {
      return this.post.comments ? this.post.comments.length : 0;
    },
    likes() {
      return this.post.likes ? this.post.likes.length : 0;
    },
    postBody() {
      const body = this.post.content.body || '';
      const split = body.split(' ');
      return split
        .map((val) => {
          if (val.startsWith('@') && val.includes('_')) {
            return val.replaceAll('_', ' ');
          } else return val;
        })
        .join(' ');
    },
  },
  methods: {
    formatTime(timestamp) {
      const date = timestamp.toDate();
      const today = moment().startOf('day');
      return moment(date).isAfter(today)
        ? moment(date).fromNow()
        : moment(date).calendar(today, {
            lastWeek: 'DD MMM [at] hh:mm A',
            sameElse: 'DD MMM [at] hh:mm A',
          });
    },
    showPost() {
      if (this.noOfComments === 0) return;
      this.$emit('show-comments', this.post);
    },
    sendMessage() {},
  },
};
</script>
